import { Button, Dropdown } from 'antd'
import Flex from 'components/Flex'
import { StyledTabs } from 'components/TabsPaneStyles'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const DropDown = styled(Dropdown)``
export const DropBtn = styled(Button)`
  .ant-btn {
    background: ${COLORS.PRIMARY_GREY_T_98} !important;
  }
`

export const StyledTab = styled(StyledTabs)`
  .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-tab {
    border-bottom: none !important;
    padding: 15px 20 !important;
  }
  .ant-tabs-nav {
    width: ${props => (props?.width ? '' : '100%')} !important;
    margin: 0 !important;
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0 0 0 15px !important;
  }
  .ant-tabs-tab-btn {
    color: ${COLORS.GREY_T_50_2};
    text-shadow: 0 0 0.25px currentcolor;
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.PRIMARY} !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.PRIMARY};
  }

  width: 100%;
  .ant-tabs-content {
    height: 250px !important;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const PaddedDiv = styled(Flex)`
  width: 100%;
  padding: 20px 25px;
  gap: 25px;
`
export const SectionWrapper = styled(Flex)`
  width: 100%;
  height: 100vh;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }
`
export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  font-size: ${FONT.F_3XL};
`
export const RoleNameFlex = styled(Flex)`
  gap: 10px;
  cursor: pointer;
`
export const TopEndFlex = styled(Flex)`
  gap: ${props => (props?.gap ? props?.gap : '0')};
`
export const LeftSection = styled(Flex)`
  gap: 20px;
`
export const SectionName = styled(Flex)`
  gap: 10px;
`
export const RoleNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  color: ${COLORS.GREY_T_20};
  margin: 10px 0 10px;
  text-transform: capitalize;
`

export const ThreeDotsDiv = styled.div`
  .ant-btn {
    background: ${COLORS.PRIMARY_GREY_T_98} !important;
    border-radius: 10px !important;
    border: 1px solid ${COLORS.GREY_T_90} !important;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    width: 38px !important;
    height: 38px !important;
  }
  cursor: pointer;
  border-left: 1px solid ${COLORS.GREY_T_90};
  padding-left: 10px;
`
export const SectinFlex = styled(Flex)``

export const CardsRowFlex = styled(Flex)`
  gap: 15px;
`
export const CardSectionFlex = styled(Flex)`
  gap: 15px;
  cursor: pointer;
`
export const CardsDiv = styled.div`
  border-right: 1px solid ${COLORS.GREY_T_90};
  padding-right: 15px;
  cursor: pointer;
`
export const CardsFlex = styled(Flex)`
  padding: 10px 15px;
  gap: 6px;
  min-width: 141px;
  min-height: 100%;
  background: ${props => (props?.isSelected ? COLORS.GREY_T_95 : COLORS.WHITE)};
  border-radius: 10px;
  border: 1px solid ${COLORS.GREY_T_90};
`
export const CardText = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREY_T_50_2};
  text-transform: capitalize;
`
export const CardsValue = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 21px;
  color: ${COLORS.GREY_T_30};
`
export const CandidatesSpan = styled.span`
  padding: 2px 6px;
  margin-left: 10px;
  width: 29px;
  height: 19px;
  background: ${COLORS.PAGE_BORDER};
  border-radius: 20px;
`
export const RoleFlex = styled(Flex)``
export const RoleNumber = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
`
export const RoleTitle = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: 14px;
  line-height: 21px;
  color: ${COLORS.GREY_T_30};
`
export const CandCount = styled.div`
  padding: 2px 10px;
  width: 37px;
  height: 19px;
  background: ${COLORS.PRIMARY};
  border-radius: 20px;

  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.WHITE};
`
export const BulkUploadDiv = styled.div`
  margin: 0 10px;

  padding-right: 10px;
`

export const HeadText = styled(Flex)`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #676e83;
  margin-top: 10px;
`
export const SubText = styled(Flex)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #999fac;
  margin-top: 10px;
`
export const SettingIconDiv = styled.div`
  height: 34px;
  width: 34px;
  background: #3249d7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
export const SettingIconClick = styled.div`
  margin-top: 2px;
  cursor: pointer;
`
export const SettingButtonDiv = styled.div`
  margin-right: 15px;
`

export const InterviewDivTop = styled.div`
  display: flex;
`
export const InterviewDivItem = styled.div`
  margin-right: 15px;
  margin-top: 10px;
`

export const Div = styled.div`
  padding-top: 20px;
`
